import React from "react";
import { AppRouter } from "@/router";
import { useThemeStore } from "@/stores/themeStore";

const App: React.FC = () => {
  const { initTheme } = useThemeStore();

  // 初始化主题
  React.useEffect(() => {
    initTheme();
  }, [initTheme]);

  return <AppRouter />;
};

export default App;
